import { z } from 'zod';
export const WorkerSupportProfileRequest = z.object({
  preferred_language: z.string().min(2).max(16),
  preferred_channel: z.enum(['app', 'web', 'whatsapp', 'voice']),
  preferred_format: z.enum(['short_text', 'steps', 'voice', 'image_text']),
  literacy_support: z.enum(['standard', 'plain', 'visual']),
  workday_start: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
  workday_end: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
  timezone: z.string().min(1).max(80),
  max_active_actions: z.number().int().min(1).max(10),
});
export const NextActionRequest = z.object({
  chain_id: z.string().min(1).max(40),
  worker_user_id: z.string().min(1).max(40),
  now: z.string().datetime({ offset: true }).optional(),
});
export const WorkerSupportResponseRequest = z.object({
  response_kind: z.enum([
    'understand',
    'need_clarification',
    'blocked',
    'missing_item',
    'unsafe',
    'out_of_role',
    'timing_conflict',
    'translation_wrong',
    'cannot_complete',
  ]),
  channel: z.enum(['app', 'web', 'whatsapp', 'voice']),
  optional_detail: z.string().max(500).optional(),
});
export type WorkerSupportProfileInput = z.infer<typeof WorkerSupportProfileRequest>;
export type NextActionInput = z.infer<typeof NextActionRequest>;
export type WorkerSupportResponseInput = z.infer<typeof WorkerSupportResponseRequest>;

export const WorkerRenderingRequest = z.object({
  modalities: z
    .array(z.enum(['app', 'web', 'whatsapp', 'voice', 'image_text', 'translated_text']))
    .min(1)
    .max(6),
  locale: z.string().min(2).max(16),
});
export const WorkerDeliveryRequest = z.object({
  channel: z.enum(['app', 'web', 'whatsapp', 'voice']),
  idempotency_key: z.string().min(8).max(120),
});
export const WorkerSupportEventRequest = z.object({
  event_kind: z.enum(['read', 'played', 'replayed', 'responded']),
  usefulness: z.number().int().min(1).max(5).optional(),
  confidence: z.number().int().min(1).max(5).optional(),
  burden_reported: z.boolean().optional(),
  bypassed: z.boolean().optional(),
  owner_intervention: z.boolean().optional(),
});
export type WorkerRenderingInput = z.infer<typeof WorkerRenderingRequest>;
export type WorkerDeliveryInput = z.infer<typeof WorkerDeliveryRequest>;
export type WorkerSupportEventInput = z.infer<typeof WorkerSupportEventRequest>;
